import {
    AjaxHelpersVue
} from '@/mixins/AjaxHelpersVue';
import {
    PopupHelpersVue
} from '@/mixins/PopupHelpersVue';
//import EventBus from '@/eventBus';

export const FormHelpersVue = {
    mixins: [AjaxHelpersVue, PopupHelpersVue],

    methods: {
        submitForm(api, data, callback) {
            setTimeout(() => {
                //this.popup('popupMessage', 'show');
            }, 500);

            this.req(api, data, res => {

                if ($.isFunction(callback)) {
                    callback(res);
                }

                /*if(this.checkProperty(res.status)) {

                  if(res.status === 'ok') {
                    if($.isFunction(callback)) {
                      callback(res);
                    }

                    // Если нужно отправить данные в попап, например, сообщение
                    EventBus.$emit('popupMessageDataLoaded', res);

                    setTimeout(() => {
                      this.popup('popupMessage', 'show');
                    }, 500);
                  }
                }*/
            }, null, 'form');
        }
    }
};